import { render, staticRenderFns } from "./DetailListRowItem.vue?vue&type=template&id=40838119&scoped=true&"
import script from "./DetailListRowItem.vue?vue&type=script&lang=js&"
export * from "./DetailListRowItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailListRowItem.vue?vue&type=style&index=0&id=40838119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40838119",
  null
  
)

export default component.exports